import { useEffect, useState } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export function useTemplateDefaults() {
  const discovery = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [defaults, setDefaults] = useState<{
    githubOwner: string;
    imageHub: string;
  }>();
  const [error, setError] = useState<string>();
  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const baseUrl = await discovery.getBaseUrl('template-provisioning');
        const response = await fetchApi.fetch(`${baseUrl}/defaults`);
        if (!response.ok) throw new Error('Unable to load template defaults');
        const value = await response.json();
        if (!value.githubOwner || !value.imageHub)
          throw new Error('Template defaults are missing');
        if (active) setDefaults(value);
      } catch (e) {
        if (active) setError(e instanceof Error ? e.message : String(e));
      }
    }
    load();
    return () => {
      active = false;
    };
  }, [discovery, fetchApi]);
  return { defaults, error };
}
